<template>
  <div class="progress-bar-wrap" :class="currentLevel.level == 3 ?'mobile-progress':''">
    <div class="row">
      <div class="progress-bar-outer col-xs-7" :class="currentLevel.level == 3 ? 'col-md-10' :'col-md-7'">
        <div class="bar-outline above" :class="[currentLevel.level === 1 ? 'silver-level': '', currentLevel.level === 2 ? 'gold-level': '', currentLevel.level === 3 ? 'prime-level': '']"><span></span></div>
          <div class="bar-outline above second-pin" :class="[currentLevel.level === 1 ? 'silver-level': '', currentLevel.level === 2 ? 'gold-level': '', currentLevel.level === 3 ? 'prime-level': '']"><span></span></div>
            <div class="bar-outline above third-pin" :class="[currentLevel.level === 1 ? 'silver-level': '', currentLevel.level === 2 ? 'gold-level': '', currentLevel.level === 3 ? 'prime-level': '']"><span></span></div>
              <div class="bar-outline above fourth-pin" v-if="currentLevel.level === 3"
              :class="currentLevel.level === 3 ? 'prime-level': ''"><span></span></div>
              <div class="bar-outline above fourth-pin" v-if="currentLevel.level === 2"
              :class="currentLevel.level === 2 ? 'gold-level': ''"><span></span></div>
                <div class="bar-outline above fifth-pin" v-if="currentLevel.level === 3"
                :class="[currentLevel.level === 2 ? 'gold-level': '', currentLevel.level === 3 ? 'prime-level': '']"><span></span></div>
                  <div class="bar-outline above sixth-pin" v-if="currentLevel.level === 3"
                  :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
                    <div class="bar-outline above seventh-pin" v-if="currentLevel.level === 3"
                    :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
                      <div class="bar-outline above eighth-pin" v-if="currentLevel.level === 3"
                      :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
                        <div class="bar-outline above ninth-pin" v-if="currentLevel.level === 3"
                        :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
                          <div class="progress-bar-inner"  v-if="currentLevel.level===0 "
                          :style="(currentLevel.name == 'Bronze') ? { width: progressWidth + '%'} : 
                          (userGameInfo && userGameInfo['Bronze']) ? '' : {width: '0%'}">
                          </div>
                          <div class="progress-bar-inner" v-if="currentLevel.level===1"
                          :style="(currentLevel.name == 'Silver') ? { width: progressWidth + '%'} : 
                          (userGameInfo && userGameInfo['Silver']) ? '' : {width: '0%'}">
                          </div>
                          <div class="progress-bar-inner" v-if="currentLevel.level===2"
                          :style="(currentLevel.name == 'Gold') ? { width: progressWidth + '%'} : 
                          (userGameInfo && userGameInfo['Gold']) ? '' : {width: '0%'}">
                          </div>
                          <div class="progress-bar-inner" v-if="currentLevel.level===3"
                          :style="(currentLevel.name == 'Prime') ? { width: progressWidth + '%'} : 
                          (userGameInfo && userGameInfo['Prime']) ? '' : {width: '0%'}">
                          </div>
                        <div class="bar-outline ninth-pin" v-if="currentLevel.level === 3"
                        :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
                      <div class="bar-outline eighth-pin" v-if="currentLevel.level === 3"
                      :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
                    <div class="bar-outline seventh-pin" v-if="currentLevel.level === 3"
                    :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
                  <div class="bar-outline sixth-pin" v-if="currentLevel.level === 3"
                  :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
                <div class="bar-outline fifth-pin" v-if="currentLevel.level === 3"
                :class="(currentLevel.level === 3) ? 'prime-level': ' '"><span></span></div>
              <div class="bar-outline fourth-pin" v-if="currentLevel.level === 3"
              :class="currentLevel.level === 3 ? 'prime-level': ''"><span></span></div>
            <div class="bar-outline fourth-pin" v-if="currentLevel.level === 2"
            :class="currentLevel.level === 2 ? 'gold-level': ''"><span></span></div>
          <div class="bar-outline third-pin" :class="[currentLevel.level === 1 ? 'silver-level': '', currentLevel.level === 2 ? 'gold-level': '', currentLevel.level === 3 ? 'prime-level': '']"><span></span></div>
        <div class="bar-outline second-pin" :class="[currentLevel.level === 1 ? 'silver-level': '', currentLevel.level === 2 ? 'gold-level': '', currentLevel.level === 3 ? 'prime-level': '']"><span></span></div>
      <div class="bar-outline" :class="[currentLevel.level === 1 ? 'silver-level': '', currentLevel.level === 2 ? 'gold-level': '', currentLevel.level === 3 ? 'prime-level': '']" 
      ><span></span></div>
     </div>
      <div class="level-name-outer col-xs-1 col-md-1">
        <p class="par" v-if="currentLevel.level != 3">Par</p>
        <div v-if="currentLevel.level === 0" class="level-svg">
          <div class="level-svg-inner">
            <span>3</span>
          </div>
          <div v-if="this.validAnswer" class="animate-svg">
            <svg v-if="this.validAnswer" class="success-svg"><use xlink:href="#success-green"></use></svg>
          </div>
          <div class="animate-svg" v-if="this.validAnswer == false">
            <svg class="failure-svg"><use xlink:href="#failure-red"></use></svg>
          </div>
          <!-- <div class="level-svg-inner" v-if="currentLevel.correctAnswers==0 && this.validAnswer == null">
            <span>3</span>
          </div> -->
        </div>
        <div v-if="currentLevel.level === 1" class="level-svg">
          <div class="level-svg-inner">
            <span>4</span>
          </div>
          <div v-if="this.validAnswer" class="animate-svg">
            <svg v-if="this.validAnswer" class="success-svg"><use xlink:href="#success-green"></use></svg>
          </div>
          <div class="animate-svg" v-if="this.validAnswer == false">
            <svg class="failure-svg"><use xlink:href="#failure-red"></use></svg>
          </div>
          <!-- <div class="level-svg-inner" v-if="currentLevel.correctAnswers==0 && this.validAnswer == null">
            <span>4</span>
          </div> -->
        </div>
        <div v-if="currentLevel.level === 2" class="level-svg">
          <div class="level-svg-inner">
            <span>5</span>
          </div>
          <div v-if="this.validAnswer" class="animate-svg">
            <svg v-if="this.validAnswer" class="success-svg"><use xlink:href="#success-green"></use></svg>
          </div>
          <div class="animate-svg" v-if="this.validAnswer == false">
            <svg class="failure-svg"><use xlink:href="#failure-red"></use></svg>
          </div>
          <!-- <div class="level-svg-inner" v-if="currentLevel.correctAnswers==0 && this.validAnswer == null">
            <span>5</span>
          </div> -->
        </div>
      </div>
      <div class="col-md-1 level-names desktop-view" v-if="currentLevel.level != 3">
        <p class="par">Par</p>
        <div class="level-name-inner">
          <svg v-if="currentLevel.level === 0"><use xlink:href="#firstlevel-yellow"></use></svg>
          <svg v-else><use xlink:href="#par3-level-success"></use></svg>
        </div>
      </div>
      <div class="col-md-1 level-names desktop-view" v-if="currentLevel.level != 3">
        <p class="par">Par</p>
        <div class="level-name-inner ">
          <svg v-if="currentLevel.level === 0"><use xlink:href="#secondlevel-black"></use></svg>
          <svg v-if="currentLevel.level === 1"><use xlink:href="#secondlevel-yellow"></use></svg>
          <svg v-if="currentLevel.level === 2"><use xlink:href="#par4-level-success"></use></svg>
        </div>
      </div>
      <div class="col-md-1 level-names desktop-view" v-if="currentLevel.level != 3">
        <p class="par">Par</p>
        <div class="level-name-inner">
          <svg v-if="currentLevel.level === 2"><use xlink:href="#thirdlevel-yellow"></use></svg>
          <svg v-if="currentLevel.level === 3"><use xlink:href="#par5-level-success"></use></svg>
          <svg v-if="currentLevel.level === 0 || currentLevel.level === 1"><use xlink:href="#thirdlevel-black"></use></svg>
        </div>
      </div>
      <div class="col-md-1 level-names desktop-view">
          <p class="par">Regluvörður</p>
        <div class="level-name-inner ">
          <svg><use xlink:href="#regluvardar_logo"></use></svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: ['currentLevel','validAnswer','userGameInfo'],
  data () {
    return {
    }
  },
  computed: {
    'progressWidth' () {
      if (this.currentLevel) {
        return (this.currentLevel.correctAnswers / this.currentLevel.minimum_valid_answers) * 100
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .progress-bar-outer {
    background: #FFFFFF;
    border: 1px solid #DBD9D9;
    box-sizing: border-box;
    border-radius: 20px;
    padding: 0;
    align-self: center;
    .progress-bar-inner {
      background: #FCBD00;
      border-radius: 20px;
      padding: 10px 0;
      position: relative;
      transition: width 0.5s ease;
    }
    .bar-outline {
      position: absolute;
      left: 33.3333%;
      &.silver-level {
        left: 25%;
      }
      &.gold-level {
        left: 20%;
      }
      &.prime-level {
        left: 10%;
      }
      &.above {
        bottom: 1.8rem;
      }
      bottom: -2.2rem;
      span {
        border-right: 1px solid #BCBCBC;
      }
      &.second-pin {
        left: 66.6667%;
        &.silver-level {
          left: 50%;
        }
        &.gold-level {
          left: 40%;
        }
        &.prime-level {
          left: 20%;
        }
      }
      &.third-pin {
        &.silver-level {
          left: 75%;
        }
        &.gold-level {
          left: 60%;
        }
        &.prime-level {
          left: 30%;
        }
      }
      &.fourth-pin {
        &.gold-level {
          left: 80%;
        }
        &.prime-level {
          left: 40%;
        }
      }
      &.fifth-pin {
        &.prime-level {
          left: 50%;
        }
      }
      &.sixth-pin {
        &.prime-level {
          left: 60%;
        }
      }
      &.seventh-pin {
        &.prime-level {
          left: 70%;
        }
      }
      &.eighth-pin {
        &.prime-level {
          left: 80%;
        }
      }
      &.ninth-pin {
        &.prime-level {
          left: 90%;
        }
      }
    }
  }
  .level-names {
    text-align: center;  
    margin-top: -2.45rem;
    padding: 1.6rem 0;
    background: #FFFFFF;
    border: 1px solid #DBD9D9;
    .level-name-inner  {
      svg {
        width: 55px;
        height: 55px;
      }
    }
  }
  .par {
    font-weight: normal;
    font-size: 12px;
    line-height: 132%;
    color: #011627;
  }
  .level-name-outer {
    align-self: center;
    padding-bottom: 13px;
    .par {
      margin-left: -1.5rem;
      margin-top: -1.8rem;
    }
    .level-svg {
      .level-svg-inner {
        border: 1px solid #DBD9D9;
        border-radius: 50%;
        width: 48px;
        height: 48px;
        background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        span {
          font-size: 30px;
          z-index: 5;
          left: 50%;
          top: 50%;
          position: absolute;
          font-weight: 500;
          transform: translate(-50%, -50%);
        }
      }
      margin-left: -3rem;
    }
  }
  .animate-svg {
    position: absolute;
    top: -3px;
    left: -25px;
    svg {
      width: 72px;
      height: 72px;
    } 
  }
.success-svg, .failure-svg {
  opacity: 0;
  // &.animated {
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-name: firework-zoomin;
    animation-iteration-count: 2;
  // }
}
@keyframes firework-zoomin {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  75% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
  }
}
</style>
